import { Flex, Text } from "@fluentui/react-northstar";
import React from "react";
import styled from "styled-components";
import TableHeader from "../constant/TableHeader";
import DynamicUserTable from "./DynamicUserTable";

export default function ListCollabTable({
    users_by_agency,
    activeTab,
    userToDisplayIntoTheTable,
    AgencyId,
}) {
    const COLLABORATEUR_EN_COURS_D_OFFBOARDING =
        users_by_agency?.offboarding_users?.length +
        users_by_agency?.waiting_offboarding_users?.length;

    return (
        <TableFlex column fill>
            <Head space="between" fill>
                <HeaderText content="Liste des collaborateurs" />

                {activeTab !== 2 && (
                    <Flex vAlign="center" gap="gap.small">
                        <Text content="Collaborateurs en cours d'offboarding" />
                        <Counter
                            content={COLLABORATEUR_EN_COURS_D_OFFBOARDING}
                        />
                    </Flex>
                )}
            </Head>

            <Flex fill column>
                <TableHeader />
                <Flex fill>
                    <DynamicUserTable
                        AgencyId={AgencyId}
                        userToDisplayIntoTheTable={userToDisplayIntoTheTable}
                        users_by_agency={users_by_agency}
                        activeTab={activeTab}
                    />
                </Flex>
            </Flex>
        </TableFlex>
    );
}

const Counter = styled(Text)`
    border-radius: 52px;
    background: var(--Blue-link, #0067b8);
    padding: 5px 10px;
    color: #fff;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

const TableFlex = styled(Flex)`
    border-top: 4px solid #9299f7;
    background: #fff;
    box-shadow: 0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07),
        0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11);
`;

const Head = styled(Flex)`
    padding: 24px 8px;
`;

const HeaderText = styled(Text)`
    color: #242424;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
`;
